import { useEffect, useRef } from "react";
import { API } from "./api";

// Subscribe to a backend SSE endpoint. The backend sends plain `data:` frames
// whose JSON carries a `type` field. onEvent receives the parsed object.
export function useEventStream(path, onEvent, enabled = true) {
  const cb = useRef(onEvent);
  cb.current = onEvent;

  useEffect(() => {
    if (!enabled || !path) return;
    let es;
    try {
      es = new EventSource(`${API}${path}`);
    } catch {
      return;
    }
    es.onmessage = (e) => {
      try {
        cb.current(JSON.parse(e.data));
      } catch {
        /* keepalive/comment frames */
      }
    };
    es.onerror = () => {
      /* browser auto-reconnects */
    };
    return () => es.close();
  }, [path, enabled]);
}
